import PropTypes from "prop-types"
import { staticLabelsPLP } from "./helper"

export default function PLPHeader({
  productCount,
  pageHeading,
  locale = "en",
}) {
  return (
    <div className="flex flex-col pt-[50px] pb-[22px] m-[10px] border-b-2 md:border-b-0 w-full">
      {/* header from CTFL */}
      <h1 className='font-["Helvetica-Light",_Helvetica,_sans-serif] max-[768px]:text-[25px] text-[30px] uppercase font-light max-[768px]:leading-[30px] leading-[38px] font-[400] text-[#232323]'>
        {pageHeading}
      </h1>
      <h6 className='text-[#999] font-["Helvetica-Light",_Helvetica,_sans-serif] leading-none font-normal'>
        {productCount} {staticLabelsPLP[locale]?.product}
      </h6>
    </div>
  )
}

PLPHeader.propTypes = {
  productCount: PropTypes.string,
  pageHeading: PropTypes.string,
}

PLPHeader.defaultProps = {
  productCount: "",
  pageHeading: "",
}
